<dx-select-box #selectBox
    [dataSource]="agentTypes"
    [value]="selectedItem"
    displayExpr="name"
    valueExpr="id"
    [disabled]="loading"
    (selectedItemChange)="onSelectedItemChange($event)">
</dx-select-box>
